import { render, staticRenderFns } from "./twoLogin.vue?vue&type=template&id=51a027d6&scoped=true"
import script from "./twoLogin.vue?vue&type=script&lang=js"
export * from "./twoLogin.vue?vue&type=script&lang=js"
import style0 from "./twoLogin.vue?vue&type=style&index=0&id=51a027d6&prod&scoped=true&lang=css"
import style1 from "./twoLogin.vue?vue&type=style&index=1&id=51a027d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a027d6",
  null
  
)

export default component.exports